var AutoSelectOnFocusDirective = {
    autoFocusDirectives: [],
    bind: function (element) {
        var onFocus = function () {
            element.select();
        };
        element.addEventListener('focus', onFocus);
        AutoSelectOnFocusDirective.autoFocusDirectives.push({
            element: element,
            onFocus: onFocus
        });
    },
    unbind: function (element) {
        for (var _i = 0, _a = AutoSelectOnFocusDirective.autoFocusDirectives; _i < _a.length; _i++) {
            var pair = _a[_i];
            if (pair.element === element) {
                element.removeEventListener('focus', pair.onFocus);
            }
        }
    }
};
export default AutoSelectOnFocusDirective;
